// If not mobile, show QR code
// If mobile, show iOS/Android 

import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory, Redirect} from 'react-router-dom';
import userStore from '../../../Stores/User';
import { observer } from 'mobx-react';
import Play from '../../DiscoverNew/Icons/Play.svg';
import Pause from '../../DiscoverNew/Icons/Pause.svg';
import { loadStripe } from '@stripe/stripe-js';
import mixpanel from 'mixpanel-browser';
import loadingIcon from '../../../Assets/loading.gif';
import { getCustomToken} from '../../../audiblogsApi';
import queryString from 'query-string';
import qr from './qr.png'
import YoutubeIframe from "../../Landing/Components/YoutubeIframe";
import QRCode from 'qrcode';
import IosInstructions from '../../SetupNew/Components/IosInstructions';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// import loadingIcon from '../../../Assets/loading.gif';
import { isMobile, isDesktop, isSafari, isChromium, isAndroid, isIOS, isChrome } from 'react-device-detect';
// Import all options from 'react-device-detect' 
import * as DeviceDetect from 'react-device-detect';
import firebase from "../../../firebase";
import ErrorIcon from '@mui/icons-material/Error';
import spotify from "../../../Assets/podcast-apps/Spotify_icon.svg";
import applepodcasts from '../../../Assets/podcast-apps/icon-applepodcasts.svg';
import breaker from '../../../Assets/podcast-apps/icon-breaker.svg';
import castbox from '../../../Assets/podcast-apps/icon-castbox.svg';
import googlepodcasts from '../../../Assets/podcast-apps/icon-googlepodcasts.svg';
import overcast from '../../../Assets/podcast-apps/icon-overcast.svg';
import playerfm from '../../../Assets/podcast-apps/icon-playerfm.svg';
import pocketcasts from '../../../Assets/podcast-apps/icon-pocketcasts.svg';
import radiopublic from '../../../Assets/podcast-apps/icon-radiopublic.svg';
import castro from '../../../Assets/podcast-apps/icon-castro.svg';
import podbean from '../../../Assets/podcast-apps/icon-podbean.svg';
import downcast from '../../../Assets/podcast-apps/downcast.png';
import podcastRepublic from '../../../Assets/podcast-apps/podcastRepublic.png';
import podcastAddict from '../../../Assets/podcast-apps/podcastAddict.png';
import thePodcastApp from '../../../Assets/podcast-apps/the-podcast-app.png';
import airr from '../../../Assets/podcast-apps/airr.svg';

// import userStore from '../../../Stores/User';
const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);

const Quickstart2 = observer( ( props) => {
  const [app, setApp] = useState('');
  const [showCTA, setShowCTA] = useState(false);
  const [quality, setQuality] = useState('Unreal');
  const [sessionId, setSessionId] = useState(null);
  const params = queryString.parse(props.location.search);
  const idToken = params.id_token;
  // const app = params.app || '';
  const [qrCode, setQrCode] = useState(null);
  const [nextStep, setNextStep] = useState(null);
  const [userFeedUrl, setUserFeedUrl] = useState(null);
  const feed_url = queryString.parse(props.location.search).feed_url;
  const applePodcastsRef = useRef(null);
  const overcastRef = useRef(null);
  const pocketCastsRef = useRef(null);
  const googlePodcastsRef = useRef(null);
  const castroRef = useRef(null);
  const radioPublicRef = useRef(null);
  const downcastRef = useRef(null);
  const [customToken, setCustomToken] = useState(params.custom_token);
  const [device, setDevice] = useState(null);
  const [signedInWithCustomToken, setSignedInWithCustomToken] = useState(false);
  const history = useHistory();

  
  useEffect(() => {
    if (customToken && !userStore.isSignedIn) {
      firebase.auth().signInWithCustomToken(customToken)
        .then((userCredential) => {
          // Signed in
          var user = userCredential.user;
          setSignedInWithCustomToken(true);
          // ...
        })
    } else if (!customToken && userStore.isSignedIn === false){
      history.push('/signin?redirected_from=onboarding/quickstart/2');
    }
  }, [customToken, userStore.isSignedIn]);

  useEffect(async () => {
    if (userStore.idToken) {
      // Use the idToken to auth Firebase and get the user object
      const result = await getCustomToken(userStore.idToken);
      setCustomToken(result.data.token)
    }
  }, [userStore.idToken]);

  useEffect(() => {
    if (userStore.userFeedUrl) {
      setUserFeedUrl(userStore.userFeedUrl);
    } else if (feed_url) {
      setUserFeedUrl(feed_url);
    }
  }, [userStore.userFeedUrl, feed_url]);

  useEffect(() => {
    if (userFeedUrl) {
      setShowCTA(true);
    }
    if (userFeedUrl) {

      try {
        // add event listner on click of the link id=apple-podcasts
        applePodcastsRef.current.addEventListener('click', () => {
          document.location.href = `podcast://${userFeedUrl.replace('https://', '')}`;
        });

        // add event listner on click of the link for Google Podcasts
        googlePodcastsRef.current.addEventListener('click', () => {
          document.location.href = `googlepodcasts://subscribe-by-rss-feed?feed=${btoa(userFeedUrl)}`;
        });

        // add event listner on click of the link for Overcast
        overcastRef.current.addEventListener('click', () => {
          document.location.href = `overcast://x-callback-url/add?url=${encodeURIComponent(userFeedUrl)}`;
        });

        // add event listner on click of the link for Pocket Casts
        pocketCastsRef.current.addEventListener('click', () => {
          alert("Episodes may take a few hours to show up. For a faster experience, use Apple Podcasts, Overcast, Google Podcasts, or another podcast app.")

          document.location.href = `pktc://subscribe/${userFeedUrl.replace('https://', '')}`;
        });

        // add event listner on click of the link for Downcast
        downcastRef.current.addEventListener('click', () => {
          document.location.href = `downcast://${userFeedUrl.replace('https://', '')}`;
        });

        // add event listner on click of the link for Castro
        castroRef.current.addEventListener('click', () => {
          // copy to clipboard
          navigator.clipboard.writeText(userFeedUrl);
          document.location.href = `castros://subscribe/${userFeedUrl.replace('https://', '')}`;
        })

        // add event listner on click of the link for Radio Public
        radioPublicRef.current.addEventListener('click', () => {
          document.location.href = `https://radiopublic.com/${encodeURIComponent(userFeedUrl)}`;
        });

      } catch (err) {
        console.log(err);
      }

    }

  }, [userFeedUrl, ]);

  useEffect(() => {
    if (userFeedUrl && !customToken) {
      QRCode.toDataURL(`${process.env.REACT_APP_FRONTEND_URL}/onboarding/quickstart/2?feed_url=${userFeedUrl}`)
        .then((url) => {
          setQrCode(url);
        })
        .catch((err) => {
          console.error(err);
        });
      }
    if (userFeedUrl && customToken) {
      QRCode.toDataURL(`${process.env.REACT_APP_FRONTEND_URL}/onboarding/quickstart/2?feed_url=${userFeedUrl}&custom_token=${customToken}`)
        .then((url) => {
          setQrCode(url);
        })
        .catch((err) => {
          console.error(err);
        });
    }

  },[userFeedUrl, customToken])

  useEffect(() => {
    if (isIOS){
      setDevice('ios')
    } else if (isAndroid){
      setDevice('android')
    } else {
      setDevice('desktop')
    }
  },[])

  const renderCTA = () => {
    return (
      <div
        className="cta-div"
        style={{ position: 'static', marginTop: '24px' }}
      >
        <button 
          className="cta-button" 
          style={{ width: '270px' }}
          onClick={() => window.location.href = '/onboarding/quickstart/3'}
        >
          Next
        </button>
        <a 
          href="#" 
          onClick={(e) => {
            e.preventDefault();
            window.location.href = '/onboarding/quickstart/3';
          }} 
          className="sub-cta-link" 
          style={{ fontSize: '16px' }}
        >
          I'll do this later
        </a>
      </div>
    );
  };

  const renderDesktop = () => {
    // If it's desktop, show QR code
    return (
      <>
        <h1 className="headline" style={{ marginBottom: '0px' }}>
          🎧 Listen in your favorite podcast app
        </h1>
        <div className="subheadline" style={{ marginTop: '0px' }}>
          Grab your phone, then scan this QR code to subscribe to your personal podcast:

        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {qrCode ? (
            <img
              src={qrCode}
              alt="your qr code"
              width="250"
              height="auto"
              style={{ margin: '30px' }}
            ></img>
          ) : (
            <img
              src={loadingIcon}
              alt="loading"
              width="50"
              height="auto"
              style={{ margin: '30px' }}
            ></img>
          )
          }
          <div style={{ textAlign: "left" }}>

            <div className='subheadline'> <b>How to scan:</b></div>

            1. Open the Camera or QR scanner app. <br></br>
            2. Point it at the QR code for 3 seconds.<br></br>
            3. Click the popup that appears.

          </div>
        </div>
        {renderCTA()}

      </>
    )
  };

  const RenderIphone = (userFeedUrl) => {
    return (<>
      <h1 className="headline" style={{ marginBottom: '0px' }}>
        Select your podcast player
      </h1>
      <div className="subheadline" style={{ marginTop: '0px' }}>
        This will open the app and subscribe to your podcast. If you're not sure, try Apple Podcasts.
      </div>

      <IosInstructions app={app} feedUrl={userFeedUrl} />
      <div className="podcast-app-container">
        <a
          ref={applePodcastsRef}
          value="Apple-Podcasts"
          className="transparent-button mobile"
        >
          <img src={applepodcasts} />
          Apple Podcasts (Recommended)
        </a>
        <a
          className="transparent-button mobile"
          onClick={(e) => setApp('Spotify')}
        >
          <img src={spotify} />
          Spotify
        </a>
        <a
          ref={googlePodcastsRef}
          className="transparent-button mobile"
        // onClick={(e) => setApp('Google Podcasts')}
        >
          <img src={googlepodcasts} />
          Google Podcasts
        </a>
        <a
          ref={overcastRef}
          className="transparent-button mobile"
        >
          <img src={overcast} />
          Overcast
        </a>
        <a
          className="transparent-button mobile"
          ref={pocketCastsRef}
        >
          <img src={pocketcasts} />
          Pocket Casts
        </a>
        

        <a
          ref={castroRef}
          className="transparent-button mobile"
        >
          <img src={castro} />
          Castro
        </a>
        <a
          ref={radioPublicRef}
          className='transparent-button mobile'
        >
          <img src={radiopublic} />
          Radio Public
        </a>
        <a
          ref={downcastRef}
          className="transparent-button mobile"
        >
          <img src={downcast} />
          Downcast
        </a>
        <a
          className="transparent-button mobile"
          onClick={(e) => setApp('Breaker')}
        >
          <img src={breaker} />
          Breaker
        </a>
        <a
          className="transparent-button mobile"
          onClick={(e) => setApp('Airr')}
        >
          <img src={airr} />
          Airr
        </a>
        <a
          className="transparent-button mobile"
          onClick={(e) => {
            alert(
              'NOTE: You may need to try subscribing twice. Also, it may take a couple of hours for new episodes to show up.'
            );
            setApp('Castbox');
          }}
        >
          <img src={castbox} />
          Castbox
        </a>
        <a
          className="transparent-button mobile"
          onClick={(e) => setApp('Podbean')}
        >
          <img src={podbean} />
          Podbean
        </a>
        <a
          className="transparent-button mobile"
          onClick={(e) => setApp('The Podcast App')}
        >
          <img src={thePodcastApp} />
          The Podcast App
        </a>
        <a
          className="transparent-button mobile"
          onClick={(e) => setApp('Other Apps')}
        >
          Other Apps
        </a>
      </div>
      {/* <a href={`${process.env.REACT_APP_FRONTEND_URL}/setupnew`} target="_blank">Having Issues? Try this link</a> */}

      {showCTA && renderCTA()}

    </>)
  }



  const RenderAndroid = (userFeedUrl) => {
    if (userFeedUrl) {
      return (<>
        <h1 className="headline" style={{ marginBottom: '0px' }}>
          Select your podcast player
        </h1>
        {/* <div className="subheadline" style={{ marginTop: '0px' }}>
          The button below will open a partner site and subscribe to your podcast.
        </div> */}
        <p>If you're not sure, try Google Podcasts</p>
        
        <div style={{ margin: "5px 0 15px 0" }}>
        <IosInstructions app={app} feedUrl={userFeedUrl} />
        <a className="transparent-button mobile" 
        
        onClick={(e) => setApp('Spotify')}
        
            style={{
              display: 'flex',
              alignItems: 'center',
              border: "2px solid white",
              justifyContent: 'center'

            }}>
              <img src={spotify} />
              Spotify</a>

          <a className="transparent-button mobile" href={`https://subscribeonandroid.com/${userFeedUrl.replace(
            "https://",
            ""
          )}`} target='_blank'
            style={{
              display: 'flex',
              alignItems: 'center',
              border: "2px solid white",
              justifyContent: 'center'

            }}>
              Other Podcast Players
            </a>
        </div>
        {/* <a href={`${process.env.REACT_APP_FRONTEND_URL}/setupnew`} target="_blank">Having Issues? Try this link</a> */}
        {showCTA && renderCTA()}


      </>)

      return (<>

        <h1 className="headline" style={{ marginBottom: '0px' }}>
          🔥 Nice! Let's listen in a podcast player
        </h1>
        <div className="subheadline" style={{ marginTop: '0px' }}>
          This will open the app and subscribe to your podcast.
        </div>
        <p>If you're not sure, try Apple Podcasts</p>

        <div className="subheadline" style={{ marginTop: '0px' }}>
          Click the first button to subscribe to your feed <br></br>
          Then, click the second button to install the app
        </div>
        <div
          className="cta-div"
          style={{ position: 'static', marginTop: '24px' }}
        >
          <button className="cta-button">

            <a
              style={{ textDecoration: 'none' }}
              href={`https://subscribeonandroid.com/${userFeedUrl.replace(
                "https://",
                ""
              )}`}
              target="_blank"

            >
              1. Connect Podcast Player
            </a>

          </button>

          {showCTA &&
            <button className="cta-button" style={{ marginTop: '10px' }}>
              <Link to="/3">2. Install Android App</Link>
              {/* <a
                // href="https://chrome.google.com/webstore/detail/audioread-ultra-realistic/fblchjbbkkaoobkhhbloehgkpdlomido" target='_blank'
                style={{ textDecoration: 'none' }}
                onClick={() => {
                  // Open the extension page
                  window.open('https://chrome.google.com/webstore/detail/audioread-ultra-realistic/fblchjbbkkaoobkhhbloehgkpdlomido', '_blank');
                  // Redirect to the main page '/'
                  window.location.href = '/add';
                }
                }
              >
                2. Install Android App
              </a> */}
            </button>
          }
        </div>

      </>)

    }
  }


  return (
    <div className="center-static">
      <div style={{display: 'flex'}}>
        <button className="transparent-button"
          style={ device === 'ios' ? {color: 'pink', border: "2px solid pink"} : null}
          onClick = {() => setDevice('ios')}
        >iOS</button>
        <button className="transparent-button"
          style={ device === 'android' ? {color: 'pink', border: "2px solid pink"} : null}
          onClick = {() => setDevice('android')}
        >Android</button>
        <button className="transparent-button"
          style={ device === 'desktop' ? {color: 'pink', border: "2px solid pink"} : null}
          onClick = {() => setDevice('desktop')}
        >Desktop</button>
      </div>
      {
        device === 'ios' ?
          RenderIphone(userFeedUrl) :
          device === 'android' ?
            RenderAndroid(userFeedUrl) :
            renderDesktop()
      }

    </div>
  );
})

export default Quickstart2;
